import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const partnerListapI = async (cat, path, search, id) => {
  console.log(id, "ididid");
  console.log(search, "searchsearchsearch");
  const requestObj = {
    path: `${path}&category=${cat}&name=${search}&source=${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const clint_list_api = async (
  page,
  limmit,
  Search,
  source,
  sector,
  client_type
) => {
  console.log(page, "client_typeclient_type");
  const requestObj = {
    path: `api/organization/list_organization?limit=${limmit}&page=${page}&text=${Search}&source=${source}&sector=${sector}&type=${client_type}&is_profile_completed=true`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const client_listapi = async (cat, path, search, id, tab, type) => {
  console.log(id, "ididid");
  console.log(search, "searchsearchsearch");
  const requestObj = {
    path: `${path}&category=${cat}&text=${search}&source=${id}&sector=${tab}&type=${type}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const partnerCategoryList = async (catid, search, path, id) => {
  const requestObj = {
    path: `${path}&source=${catid}&name=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const api_hr_blogs = async (page, limit, catid, search) => {
  console.log(search, "searchsearchsearchsearch");
  const requestObj = {
    path: `api/hr_category/client_list?page=${page}&limit=${limit}&source=${catid}&name=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_partner_detail_api = async (id) => {
  const requestObj = {
    path: `api/partner/detail/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const get_client_detail_for_sectors = async (id) => {
  const requestObj = {
    path: `api/organization/detail_organization/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_interview_list_api = async (catid, path) => {
  const requestObj = {
    path: `${path}&source=${catid}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_interview_list_blog_api = async (catid, search, path) => {
  const requestObj = {
    path: `${path}&category=${catid}&name=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const _get_mindset_list_blog_api = async (catid, search, path) => {
  const requestObj = {
    path: `${path}&source=${catid}&name=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const _get_JD_list_blog_api = async (catid, search, path) => {
  const requestObj = {
    path: `${path}&source=${catid}&name=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_job_feed_list_blog_api_without_filters = async (
  catid,
  search,
  path
) => {
  const requestObj = {
    path: `${path}&search=${search}&created_for=${catid}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const upload_image_documents_on_s3 = async (data) => {
  const requestObj = {
    path: `api/app_api/upload_image_s3`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _get_job_feed_list_blog_api = async (
  catid,
  search,
  path,
  filters = {}
) => {
  let dateQuery = "";
  if (filters.last24Hours) {
    dateQuery = "&last24Hours=true";
  } else if (filters.startDate && filters.endDate) {
    dateQuery = `&startDate=${encodeURIComponent(
      filters.startDate
    )}&endDate=${encodeURIComponent(filters.endDate)}`;
  }

  const filterQuery = `&location=${encodeURIComponent(
    filters.location || ""
  )}&education=${encodeURIComponent(
    filters.education || ""
  )}&jobType=${encodeURIComponent(
    filters.jobType || ""
  )}&experience=${encodeURIComponent(
    filters.experience || ""
  )}&minSalary=${encodeURIComponent(
    filters.minSalary || ""
  )}&maxSalary=${encodeURIComponent(
    filters.maxSalary || ""
  )}&frequencySalary=${encodeURIComponent(
    filters.frequencySalary || ""
  )}&clientName=${encodeURIComponent(filters.clientName || "")}${dateQuery}`;

  console.log(filterQuery, "filterQueryfilterQuery");
  const requestObj = {
    path: `${path}&search=${search}${filterQuery}&created_for=${catid}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const get_outside_jobs_api = async (catid, search, path) => {
  const requestObj = {
    path: `${path}&created_for=${catid}&search=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_job_outside_api = async (catid, search, path) => {
  const requestObj = {
    path: `${path}&search=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_favourites_job_api = async (catid, search, path) => {
  const requestObj = {
    path: `${path}&created_for=${catid}&search=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_personal_jobs_feed_api = async (search, path) => {
  const requestObj = {
    path: `${path}&search=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_tempingt_blog_api = async (catid, search, path) => {
  const requestObj = {
    path: `${path}&source=${catid}&name=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const candidates_list_api = async (Search) => {
  const requestObj = {
    path: `api/jobs/job_application_list/${Search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_training_list_blog_api = async (catid, search, path) => {
  const requestObj = {
    path: `${path}&source=${catid}&name=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_training_list_blog_api_new = async (catid, search, path) => {
  const requestObj = {
    path: `${path}&category=${catid}&name=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const _get_mindset_list_blog_api_new = async (catid, search, path) => {
  const requestObj = {
    path: `${path}&category=${catid}&name=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const _get_JD_list_blog_api_new = async (catid, search, path) => {
  const requestObj = {
    path: `${path}&category=${catid}&name=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_mindset_blog_etail_api = async (id) => {
  const requestObj = {
    path: `api/mindset_source_blog/detail/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const post_job_feed_api = async (data) => {
  const requestObj = {
    path: `api/jobs`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_job_api = async (id, data) => {
  const requestObj = {
    path: `api/jobs/update/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const favourite_live_job_api = async (data) => {
  const requestObj = {
    path: `api/jobs/make_job_favorite`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const get_hr_blog_etail_api = async (id) => {
  const requestObj = {
    path: `api/hr_blog/detail/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_live_job_feed_etail_api = async (id) => {
  const requestObj = {
    path: `api/jobs/detail/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const apply_job_api = async (data) => {
  const requestObj = {
    path: `api/jobs/apply_for_job`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const get_training_blog_etail_api = async (id) => {
  const requestObj = {
    path: `api/training_source_blog/detail/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const get_JD_blog_etail_api = async (id) => {
  const requestObj = {
    path: `api/job_description_blog/detail/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const get_JD_temping_etail_api = async (id) => {
  const requestObj = {
    path: `api/temping_blog/detail/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_interview_list_blog_detail_api = async (id) => {
  const requestObj = {
    path: `api/interview_blog/detail/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const delete_live_job_feed_api = async (member_user_id) => {
  const requestObj = {
    path: `api/jobs/delete/${member_user_id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_leader_in_the_industry_api = async (id, path) => {
  const requestObj = {
    path: `${path}&category=${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_leader_industry_all_api = async (
  catid,
  search,
  path,
  type
) => {
  const requestObj = {
    path: `${path}&category=${catid}&name${search}&type=${type}&status=true`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_leader_detail_api = async (id) => {
  const requestObj = {
    path: `api/leaders/detail/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

/////////===================source api=================/////
export const sourceListApi = async (page, limmit, Search) => {
  const requestObj = {
    path: `api/source/get_list?limit=${limmit}&page=${page}&text=${Search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const sections_inside_source_api = async (page, limmit, Search) => {
  const requestObj = {
    path: `api/source/get_list_features?limit=${limmit}&page=${page}&text=${Search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

// feed api list

//applied job ist
export const applied_hob_list_for_candidate_client = async (
  Search,
  createdFor,
  page,
  limit
) => {
  console.log(createdFor, "createdForcreatedFor");
  const requestObj = {
    path: `api/jobs/applied_job_list?search=${Search}&created_for=${createdFor}&page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const add_new_feed = async (data) => {
  const requestObj = {
    path: `api/feed`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const update_new_feed = async (data, id) => {
  const requestObj = {
    path: `api/feed/update/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

// ================client details================================//
export const client_detail_api = async (id) => {
  const requestObj = {
    path: `api/organization/detail_organization/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const candidate_api_detail_fetch = async (id) => {
  const requestObj = {
    path: `api/customer/detail_customer/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const client_profile_edit_api = async (id, data) => {
  const requestObj = {
    path: `api/organization/update_organization_by_admin/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const candidate_edit_profile_api = async (id, data) => {
  const requestObj = {
    path: `api/customer/update_customer_by_admin/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const edit_profile_user_candidate_api = async (id, data) => {
  const requestObj = {
    path: `api/customer/update_customer_by_admin/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_feed_image_on_s3 = async (data) => {
  const requestObj = {
    path: `api/app_api/upload_image_s3`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const get_feeds_list = async (loadMore, id, type) => {
  const requestObj = {
    path: `${loadMore}&search=&created_for=${id}&post_type=${type}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const get_feeds_detail_api = async (loadMore, Id) => {
  const requestObj = {
    // path: `api/feed/detail/${Id}?page=${page}&limit=${limmit}`,
    path: `${loadMore}/${Id}`,

    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const detail_feed_api = async (Id) => {
  const requestObj = {
    path: `api/feed/detail/${Id}?page=0&limit=50`, // Correct URL structure
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const delete_feed_action = async (feed_id) => {
  const requestObj = {
    path: `api/feed/${feed_id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const delete_comment_api = async (id) => {
  const requestObj = {
    path: `api/feed/delete_feed_comment/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const like_feed_api = async (id) => {
  const requestObj = {
    path: `api/feed/like_unlike_feed/${id}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: {},
  };
  return invokeApi(requestObj);
};

export const add_feed_comment = async (data) => {
  const requestObj = {
    path: `api/feed/add_feed_comment`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const update_feed_comment = async (data, id) => {
  const requestObj = {
    path: `api/feed/update_feed_comment/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const like_unlike_feed_comment = async (id) => {
  const requestObj = {
    path: `api/feed/like_unlike_feed_comment/${id}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: {},
  };
  return invokeApi(requestObj);
};
// ====================image upload
export const s3ImageUpload = async (data) => {
  const requestObj = {
    path: `api/app_api/upload_image_s3`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const change_client_password_api = async (id, data) => {
  const requestObj = {
    path: `api/app_api/user_change_password/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const reset_pop_up_api_for_clients_candidates = async (data) => {
  const requestObj = {
    path: `api/app_api/reset_password`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const complete_profile_update_api = async (data) => {
  const requestObj = {
    path: `api/app_api/enhanced_reset_password`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const feedback_api_by_web = async (data) => {
  const requestObj = {
    path: `api/app_api/feedback`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const admin_default_setting_without_auth = async () => {
  const requestObj = {
    path: `api/admin_portal_settings/get_admin_portal_settings`,
    method: "GET",
    headers: {},
  };
  return invokeApi(requestObj);
};
